
<div class="sip-dock">
  <div class="content">
    <div class="text">Start Monthly Contributions to save lives</div>
    <div class="btn-container">
      <button (click)="redirect()" mat-raised-button>Start monthly giving</button>
    </div>
  </div>
</div>